import { IMappedProductTreeItem } from 'partner360/components/filters'

export const getChildrenByRoot = (
  root: string,
  items: IMappedProductTreeItem[]
): IMappedProductTreeItem[] => {
  const children: IMappedProductTreeItem[] = []

  const directChildren = items.filter((item) => item.parentId === root)
  children.push(...directChildren)

  for (const child of directChildren) {
    children.push(...getChildrenByRoot(child.itemId, items))
  }

  return children
}
